import { DeviceEnum } from "@/domains/business/constants/deviceEnum";
import useBusinessSell from "@/domains/business/hooks/useBusinessSell";
import BusinessSellModal from "@/domains/business/components/BusinessSellModal";

type Props = {
  setIsShow: (isShow: boolean) => void;
  device: DeviceEnum;
  onSuccessSell?: () => void;
};

export default function BusinessSellContainer({ setIsShow, device, onSuccessSell }: Props) {
  const { price, business, sell, isSelling, isLoading } = useBusinessSell({
    setIsShow,
    device,
    onSuccessSell,
  });
  const address = business?.address
    ? `${business.address.streetName} ${business.address.index}`
    : "";

  return (
    <BusinessSellModal
      businessId={business?.id}
      price={price}
      onClose={() => setIsShow(false)}
      onConfirm={sell}
      address={address}
      isLoading={isLoading}
      isConfirming={isSelling}
    />
  );
}
